/**
 * @file コンポーネント：フル動画ページ リンクボタン ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnPushDataLayerGtm } from "~/src/functions/common";
import { fnSendEventHubspot } from "~/src/functions/hubspot";

// コンポーネントを返す
export const ButtonLink = (props) => {

    // Presenterに渡す
    return <Presenter {...props} />;
};
